import { RouteConfig } from 'vue-router';

import Routes from './views/routes';

export const routes: Array<RouteConfig> = [
  {
    path: 'app',
    component: () => import('./index.vue'),
    children: [
      ...Routes,
    ],
  },
];

export default routes;
